import { createAction, props } from '@ngrx/store';
export const setCustomGrowthAmount = createAction('[Fund Chart] Set custom growth amount', props());
